import { useQuery } from '@tanstack/react-query';
import { settingsApi, CountryMetadata } from '@/api/endpoints/settings';

/**
 * Fetch country-specific UI metadata (field format hints, etc.) from the
 * backend profile pack. Cached for 24 hours — profile packs are static per
 * deployment and change only when an admin reloads them.
 *
 * Pass `null`/`undefined` to disable the query (e.g. while the active
 * company hasn't loaded yet). Callers typically read the country code
 * from `authStore.activeCompany.country_code`.
 */
export function useCountryMetadata(
  countryCode: string | null | undefined,
  sections: string[] = ['formats'],
) {
  const normalized = countryCode?.toUpperCase() || null;
  const sectionsKey = [...sections].sort().join(',');

  return useQuery<CountryMetadata>({
    queryKey: ['country-metadata', normalized, sectionsKey],
    queryFn: () =>
      settingsApi.getCountryMetadata(normalized!, sections).then((r) => r.data),
    enabled: !!normalized,
    staleTime: 24 * 60 * 60 * 1000, // 24h — profile packs are static
    gcTime: 24 * 60 * 60 * 1000,
  });
}
